
export const normalizePlan = (plan) => ({
  id: plan?.id ?? plan?.subscriptionPlanId ?? plan?.value ?? plan?.planName,
  planName: plan?.planName || plan?.name || plan?.title || 'Plan',
  planCode: String(plan?.planCode || plan?.code || plan?.planName || '')
    .trim()
    .toLowerCase(),
  monthlyPrice:
    plan?.monthlyPrice ??
    plan?.monthlyFee ??
    plan?.subscriptionFee ??
    plan?.price ??
    0,
  yearlyPrice:
    plan?.yearlyPrice ??
    plan?.yearlyFee ??
    plan?.annualPrice ??
    plan?.annualFee ??
    null,
  displayCurrency: plan?.displayCurrency || plan?.currencySymbol || '$',
  currencyCode: plan?.currencyCode || 'USD',
  setupFee: plan?.setupFee ?? plan?.oneTimeSetupFee ?? 0,
  yearlySetupFee: plan?.yearlySetupFee ?? plan?.setupFee ?? 0,
  description: plan?.description || plan?.summary || '',
  features: Array.isArray(plan?.features)
    ? plan.features
    : ['Feature 1', 'Feature 2', 'Feature 3', 'Feature 4'],
  customizationNote: plan?.customizationNote || plan?.customizationDescription || '',
  financialSupportDetails: plan?.financialSupportDetails || [],
});
